import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type CountryStore = {
  countryCode: string;
  setCountryCode: (code: string) => void;
};

export const useCountryStore = create<CountryStore>()(
  persist(
    (set) => ({
      countryCode: 'KR',
      setCountryCode: (code) => set({ countryCode: code }),
    }),
    {
      name: 'country-code', // localStorage 키
      version: 1,
    }
  )
);
